import { useMediaQuery } from '@material-ui/core';
import { SnackbarOrigin } from '@material-ui/core/Snackbar/Snackbar';
import { useTheme } from '@material-ui/core/styles';
import { useMemo } from 'react';

export const useMobileSnackBarPosition = () => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  // displaying the snack bar in the top in mobile to avoid the chat widget overlapping
  const messagePosition = useMemo(
    () => (isMobile ? ({ vertical: 'top', horizontal: 'center' } as SnackbarOrigin) : undefined),
    [isMobile],
  );

  return { messagePosition };
};
